module.exports = __webpack_public_path__ + "static/media/ucatolica.ae07364c.webp";